// This schema is used to faciliate section prefilling for the 9035
// '9035': ['A', 'B', 'C', 'D', 'E', 'G']

export const sectionTitles = [
  { prefix: "A", name: "Employment-Based Nonimmigrant Visa Information" },
  { prefix: "B", name: "Temporary Need Information" },
  { prefix: "C", name: "Employer Information" },
  { prefix: "D", name: "Employer Point of Contact Information" },
  { prefix: "E", name: "Attorney or Agent Information" },
  { prefix: "G", name: "Employment and Wage Information" },
];

export default {
  A: ["a1_visa_type"],
  B: [
    "b1_job_title",
    // 'b2_soc_code',
    // 'b3_soc_title',
    "b4_is_full_time",
    "b5_begin_date",
    "b6_end_date",
    "b7_total_positions",
    "b7a_new_employment",
    "b7b_continuation",
    "b7c_change_approved",
    "b7d_new_concurrent",
    "b7e_change_employer",
    "b7f_amended_petition",
  ],
  C: [
    "c1_emp_name",
    "c2_emp_dba",
    "c12_emp_fein",
    "c13_emp_naics_description",
    "c13_emp_naics",
    "c3_emp_address_1",
    "c4_emp_address_2",
    "c8_emp_country_id",
    "c5_emp_city",
    "c6_emp_state_id",
    "c9_emp_province",
    "c7_emp_zip",
    "c10_emp_phone",
    "c11_emp_phone_ext",
  ],
  D: [
    "d1_poc_last",
    "d2_poc_first",
    "d3_poc_middle",
    "d4_poc_title",
    "d5_poc_address_1",
    "d6_poc_address_2",
    "d7_poc_city",
    "d8_poc_state_id",
    "d9_poc_zip",
    "d10_poc_country_id",
    "d11_poc_province",
    "d12_poc_phone",
    "d13_poc_phone_ext",
    "d14_poc_email",
  ],
  E: [
    "e1_is_represented",
    "e2_agent_last",
    "e3_agent_first",
    "e4_agent_middle",
    "e5_agent_address_1",
    "e6_agent_address_2",
    "e7_agent_city",
    "e8_agent_state_id",
    "e9_agent_zip",
    "e10_agent_country_id",
    "e11_agent_province",
    "e12_agent_phone",
    "e13_agent_phone_ext",
    "e14_agent_email",
    "e15_agent_firm_name",
    "e16_agent_firm_fein",
    "e17_agent_bar_number",
    "e18_agent_court_state_id",
    "e19_agent_court_name",
  ],
  G: ["g1_read_agree"],
};
